import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Lock } from "lucide-react";
import { login } from "../services/LoginService"; // seu service real de login

const Login = () => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);
  const navigate = useNavigate();

  // Função chamada ao clicar nos botões do PIN
  const handlePinInput = async (digit: string) => {
    if (pin.length < 4) {
      const newPin = pin + digit;
      setPin(newPin);
      setError(false);

      if (newPin.length === 4) {
        try {
          // Chama seu backend
          const result = await login(newPin);
          // Salva token JWT no sessionStorage
          sessionStorage.setItem("token", result.token);
          navigate("/"); // redireciona para home
        } catch (err) {
          setError(true);
          setShake(true);
          setTimeout(() => {
            setPin("");
            setShake(false);
          }, 500);
        }
      }
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
    setError(false);
  };

  const handleClear = () => {
    setPin("");
    setError(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/20 via-secondary/20 to-accent/20 flex items-center justify-center p-4">
      <div className="bg-card/80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 w-full max-w-sm border border-primary/20">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Lock className="w-10 h-10 text-primary-foreground" />
          </div>
          <h1 className="text-2xl font-serif text-foreground mb-2">Nosso Cantinho</h1>
          <p className="text-muted-foreground text-sm">Digite o PIN para entrar</p>
        </div>

        {/* PIN Display */}
        <div className={`flex justify-center gap-3 mb-8 ${shake ? "animate-shake" : ""}`}>
          {[0, 1, 2, 3].map((index) => (
            <div
              key={index}
              className={`w-14 h-14 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
                pin.length > index
                  ? error
                    ? "bg-destructive/20 border-destructive"
                    : "bg-primary/20 border-primary"
                  : "bg-muted/50 border-border"
              }`}
            >
              {pin.length > index && (
                <Heart
                  className={`w-6 h-6 ${error ? "text-destructive" : "text-primary"} fill-current`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Error message */}
        {error && (
          <p className="text-destructive text-center text-sm mb-4 animate-fade-in">
            PIN incorreto, tente novamente
          </p>
        )}

        {/* Keypad */}
        <div className="grid grid-cols-3 gap-3">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => (
            <button
              key={digit}
              onClick={() => handlePinInput(digit.toString())}
              className="h-16 rounded-2xl bg-muted/50 hover:bg-primary/20 text-foreground text-xl font-medium transition-all duration-200 hover:scale-105 active:scale-95 border border-border hover:border-primary/50"
            >
              {digit}
            </button>
          ))}
          <button
            onClick={handleClear}
            className="h-16 rounded-2xl bg-muted/50 hover:bg-destructive/20 text-muted-foreground text-sm font-medium transition-all duration-200 hover:scale-105 active:scale-95 border border-border hover:border-destructive/50"
          >
            Limpar
          </button>
          <button
            onClick={() => handlePinInput("0")}
            className="h-16 rounded-2xl bg-muted/50 hover:bg-primary/20 text-foreground text-xl font-medium transition-all duration-200 hover:scale-105 active:scale-95 border border-border hover:border-primary/50"
          >
            0
          </button>
          <button
            onClick={handleDelete}
            className="h-16 rounded-2xl bg-muted/50 hover:bg-accent/30 text-muted-foreground text-sm font-medium transition-all duration-200 hover:scale-105 active:scale-95 border border-border hover:border-accent/50"
          >
            Apagar
          </button>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-muted-foreground text-xs flex items-center justify-center gap-1">
            Feito com <Heart className="w-3 h-3 text-primary fill-current" /> para nós
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
